import { SVGProps } from 'react';

const CornerRightUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m20 9-5-5-5 5m5-5v12a4 4 0 0 1-4 4H4"
    />
  </svg>
);
export default CornerRightUp;
